import { useState } from 'react';

/**
 * Like useState, but backed by sessionStorage under `key`.
 * Survives unmount/remount of the owning page (e.g. navigating away and back)
 * without leaking across browser tabs or persisting past the session.
 */
export function useSessionState(key, initialValue = null) {
  const [state, setState] = useState(() => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setPersistedState = (value) => {
    setState(value);
    try {
      if (value === null || value === undefined) {
        sessionStorage.removeItem(key);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    } catch {
      // sessionStorage unavailable (private mode, quota) — state still works in-memory
    }
  };

  return [state, setPersistedState];
}
